import {  FormControl } from "@mui/material";
import InputTheme from "../../generic/input";
import { LangContext } from "../../../contexts/LangContext";
import { useContext } from "react";
import React from "react";


export default function InputFile({ errorText, ...props }) {
  const { lang } = useContext(LangContext);



  return (
    <FormControl sx={{ width: "100%", variant: "standard", }}>
      <InputTheme
        // InputProps={{
        //   endAdornment: (
        //     <Button
        //       variant="contained"
        //       color="blueSys"
        //       sx={{ textTransform: "initial" }}
        //       {...props}
        //     >
        //       Procurar imagem
        //     </Button>
        //   ),
        // }}
        accept="image/png, image/jpeg" onClick={(e) => {e.target.value = ""}}
        error={props.error}
        helperText={errorText ? "" : errorText}
        {...props}
        type="file"
      />
      
    </FormControl>
  );
}
